module.exports = __webpack_public_path__ + "static/img/avatar_4.90f5706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/avatars/avatar_4.png
// module id = hrMK
// module chunks = 0